import React from 'react';
import '../styles/modern-invoice.css';

const GoogleReviewPopup = ({ isOpen, onClose, reviewUrl }) => {
  if (!isOpen || !reviewUrl) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="review-modal">
        <button 
          className="modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        
        <div className="review-content">
          <div className="review-icon">⭐</div>
          <h3 className="review-title">Enjoying our service?</h3>
          <p className="review-description">
            We'd love your feedback! Please leave us a Google review 
            to help us grow and serve you better.
          </p>
          
          <a
            href={reviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="review-button"
          >
            Leave a Google Review
          </a>
        </div>
      </div>
    </div>
  );
};

export default GoogleReviewPopup; 